import {DojoDeshi} from './DojoDeshi.js';
import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';
import signals from './lib/signals.js';

import {ClassRecordSummaryTableRow} from './ClassRecordSummaryTableRow.js';

export class ClassRecordSummaryTableController {
	constructor() {
		let s = document.querySelectorAll('.class-record');
		for (let i=0; i<s.length; i++) {
			new ClassRecordSummaryTableRow(s[i]);
		}
	}
}

window.ClassRecordSummaryTableController = ClassRecordSummaryTableController;